export const RootRoute = '/dashboard';

const TransactionsRoot = `${RootRoute}/adm-transactions`;
export const TransactionsRoutes = {
  root: TransactionsRoot,
  index: `${TransactionsRoot}/index`,
  details: `${TransactionsRoot}/details`,
};

const RetailerTransactionsRoot = `${RootRoute}/rt-transactions`;
export const RetailerTransactionsRootes = {
  root: RetailerTransactionsRoot,
  index: `${RetailerTransactionsRoot}/index`,
  details: `${RetailerTransactionsRoot}/details`,
};

const DistributorTransactionsRoot = `${RootRoute}/db-transactions`;
export const DistributorTransactionsRootes = {
  root: DistributorTransactionsRoot,
  index: `${DistributorTransactionsRoot}/index`,
  details: `${DistributorTransactionsRoot}/details`,
};
//------------------ SPECIFICATION Routes ------------------
const SpecificationAdminRoot = `${RootRoute}/adm-specification`;
export const SpecificationAdminRoutes = {
  root: SpecificationAdminRoot,
  index: `${SpecificationAdminRoot}/index`,
  details: `${SpecificationAdminRoot}/details`,
};

const SpecificationRoot = `${RootRoute}/specification`;
export const SpecificationRootes = {
  root: SpecificationRoot,
  index: `${SpecificationRoot}/index`,
  details: `${SpecificationRoot}/details`,
  buildIndex: (partnerId: string) => `${SpecificationRoot}/${partnerId}/index`,
};

//------------------ CMS Routes ------------------
const CMSRoot = `${RootRoute}/cms`;
const TagRoot = `${CMSRoot}/tags`;
export const TagRoutes = {
  root: TagRoot,
  index: `${TagRoot}/index`,
  details: `${TagRoot}/details`,
  create: `${TagRoot}/create`,
  update: `${TagRoot}/update`,
};
const CategoriesRoot = `${CMSRoot}/categories`;
export const CategoriesRoutes = {
  root: CategoriesRoot,
  index: `${CategoriesRoot}/index`,
  details: `${CategoriesRoot}/details`,
  create: `${CategoriesRoot}/create`,
  update: `${CategoriesRoot}/update`,
};
const PagesRoot = `${CMSRoot}/pages`;
export const PagesRoutes = {
  root: PagesRoot,
  index: `${PagesRoot}/index`,
  details: `${PagesRoot}/details`,
  create: `${PagesRoot}/create`,
  update: `${PagesRoot}/update`,
};
const PostsRoot = `${CMSRoot}/posts`;
export const PostsRoutes = {
  root: PostsRoot,
  index: `${PostsRoot}/index`,
  details: `${PostsRoot}/details`,
  create: `${PostsRoot}/create`,
  update: `${PostsRoot}/update`,
};
const BannersRoot = `${CMSRoot}/banners`;
export const BannersRoutes = {
  root: BannersRoot,
  index: `${BannersRoot}/index`,
  details: `${BannersRoot}/details`,
  create: `${BannersRoot}/create`,
  update: `${BannersRoot}/update`,
};
//------------------ Loyality Routes ------------------
// ProductRoutes
const ProductsRoot = `${RootRoute}/products/distributor/:distributorId/brand/:brandId`;
export const ProductsRoutes = {
  root: ProductsRoot,
  index: `${ProductsRoot}/index`,
  buildIndex: (distributorId: string, brandId: string) =>
    `${RootRoute}/products/distributor/${distributorId}/brand/${brandId}/index`,
  details: `${ProductsRoot}/details/:id`,
  buildDetails: (distributorId: string, brandId: string, id: string) =>
    `${RootRoute}/products/distributor/${distributorId}/brand/${brandId}/details/${id}`,
  create: `${ProductsRoot}/create`,
  buildCreate: (distributorId: string, brandId: string) =>
    `${RootRoute}/products/distributor/${distributorId}/brand/${brandId}/create`,
  update: `${ProductsRoot}/update/:id`,
  buildUpdate: (distributorId: string, brandId: string, id: string) =>
    `${RootRoute}/products/distributor/${distributorId}/brand/${brandId}/update/${id}`,
  addProductImage: `${ProductsRoot}/add-product-image/:id`,
  buildAddProductImage: (distributorId: string, brandId: string, id: string) =>
    `${RootRoute}/products/distributor/${distributorId}/brand/${brandId}/add-product-image/${id}`,
};
// PartnerRoutes
const PartnersRoot = `${RootRoute}/partners`;
const DistributorsRoot = `${PartnersRoot}/distributors`;
const RetailersRoot = `${PartnersRoot}/retailers`;
const PosUsersRoot = `${RootRoute}/pos-users/retailer/:retailerId`;
const BrandsRoot = `${RootRoute}/brands/distributor/:distributorId`;
const PartnerUsersRoot = `${RootRoute}/partner-users/partner/:partnerId`;
export const DistributorsRoutes = {
  root: DistributorsRoot,
  index: `${DistributorsRoot}/index`,
  details: `${DistributorsRoot}/details`,
  create: `${DistributorsRoot}/create`,
  update: `${DistributorsRoot}/update`,
  profile: `${DistributorsRoot}/profile`,
  brandIndex: `${DistributorsRoot}/index-distributor-view`,
  brandDetails: `${DistributorsRoot}/brand-details`,
  productsIndex: `${DistributorsRoot}/index-products`,
  productDetails: `${DistributorsRoot}/products-details`,
};
export const RetailersRoutes = {
  root: RetailersRoot,
  index: `${RetailersRoot}/index`,
  details: `${RetailersRoot}/details`,
  create: `${RetailersRoot}/create`,
  update: `${RetailersRoot}/update`,
  profile: `${RetailersRoot}/profile`,
  posUserIndex: `${RetailersRoot}/index-pos-user-view`,
  posUserDetails: `${RetailersRoot}/pos-user-details`,
};
export const BrandsRoutes = {
  root: BrandsRoot,
  index: `${BrandsRoot}/index`,
  buildIndex: (distributorId: string) => `${RootRoute}/brands/distributor/${distributorId}/index`,
  details: `${BrandsRoot}/details/:id`,
  buildDetails: (distributorId: string, id: string) =>
    `${RootRoute}/brands/distributor/${distributorId}/details/${id}`,
  create: `${BrandsRoot}/create`,
  buildCreate: (distributorId: string) => `${RootRoute}/brands/distributor/${distributorId}/create`,
  update: `${BrandsRoot}/update/:id`,
  buildUpdate: (distributorId: string, id: string) =>
    `${RootRoute}/brands/distributor/${distributorId}/update/${id}`,
};
export const PosUsersRoutes = {
  root: PosUsersRoot,
  index: `${PosUsersRoot}/index`,
  buildIndex: (retailerId: string) => `${RootRoute}/pos-users/retailer/${retailerId}/index`,
  details: `${PosUsersRoot}/details/:id`,
  buildDetails: (retailerId: string, id: string) =>
    `${RootRoute}/pos-users/retailer/${retailerId}/details/${id}`,
  create: `${PosUsersRoot}/create`,
  buildCreate: (retailerId: string) => `${RootRoute}/pos-users/retailer/${retailerId}/create`,
  addSimpleCashbackSpecification: `${PosUsersRoot}/add-simple-cashback-specification/:id`,
  buildAddSimpleCashbackSpecification: (retailerId: string, id: string) =>
    `${RootRoute}/pos-users/retailer/${retailerId}/add-simple-cashback-specification/${id}`,
  addCascadingCashbackSpecification: `${PosUsersRoot}/add-cascading-cashback-specification/:id`,
  buildAddCascadingCashbackSpecification: (retailerId: string, id: string) =>
    `${RootRoute}/pos-users/retailer/${retailerId}/add-cascading-cashback-specification/${id}`,
  createCustomTransaction: `${PosUsersRoot}/create-custom-transaction/:id`,
  buildCreateCustomTransaction: (retailerId: string, id: string) =>
    `${RootRoute}/pos-users/retailer/${retailerId}/create-custom-transaction/${id}`,
};
export const PartnerUsersRoutes = {
  root: PartnerUsersRoot,
  index: `${PartnerUsersRoot}/index`,
  buildIndex: (partnerId: string) => `${RootRoute}/partner-users/partner/${partnerId}/index`,
  details: `${PartnerUsersRoot}/details/:id`,
  buildDetails: (partnerId: string, id: string) =>
    `${RootRoute}/partner-users/partner/${partnerId}/details/${id}`,
  create: `${PartnerUsersRoot}/create`,
  buildCreate: (partnerId: string) => `${RootRoute}/partner-users/partner/${partnerId}/create`,
};

export const ProductMatchIndex = `${PartnersRoot}/product-match`;

export const EnterProductNames = `${PartnersRoot}/product-names-entry`;

// CodeBookRoutes
export const CodeBookIndex = `${RootRoute}/codebook`;
// BlackListRoutes
const BlackListRoot = `${RootRoute}/blacklist`;
export const BlackListRoutes = {
  root: BlackListRoot,
  index: `${BlackListRoot}/index`,
};
// WhiteListRoutes
export const WhiteListIndex = `${RootRoute}/whitelist`;
// InvoicesRoutes
const InvoicesRoot = `${RootRoute}/invoices`;
export const InvoicesRoutes = {
  root: InvoicesRoot,
  indexWithErrors: `${InvoicesRoot}/invoices-with-errors`,
};
//ReportsRoutes
const ReportsRoot = `${RootRoute}/reports`;
export const ReportsRoutes = {
  root: ReportsRoot,
  indexDailyPayments: `${ReportsRoot}/index-daily-payments`,
};
//ContractorRoutes
const ContractorsRoot = `${RootRoute}/contractors`;
export const ContractorsRoutes = {
  root: ContractorsRoot,
  index: `${ContractorsRoot}/index`,
  indexRisk: `${ContractorsRoot}/risk/index`,
  details: `${ContractorsRoot}/details/:id`,
  detailsRisk: `${ContractorsRoot}/risk/details/:id`,
  buildDetails: (contractorId: number) => `${RootRoute}/contractors/details/${contractorId}`,
  buildDetailsRisk: (contractorId: number) =>
    `${RootRoute}/contractors/risk/details/${contractorId}`,
};
// UserRoutes
const EndUsersRoot = `${RootRoute}/end-users`;
export const EndUsersRoutes = {
  root: EndUsersRoot,
  index: `${EndUsersRoot}/index`,
  details: `${EndUsersRoot}/details/:id`,
  buildDetails: (endUserId: string) => `${RootRoute}/end-users/details/${endUserId}`,
  create: `${EndUsersRoot}/create`,
  transactionDetails: `${EndUsersRoot}/details/:id/transactions/details/:transactionId`,
  buildTransactionDetails: (endUserId: string, transactionId: string) =>
    `${RootRoute}/end-users/details/${endUserId}/transactions/details/${transactionId}`,
  fiscalBillDetails: `${EndUsersRoot}/details/:id/fiscal-bills/details/:fiscalBillId`,
  buildfiscalBillDetails: (endUserId: string, fiscalBillId: string) =>
    `${RootRoute}/end-users/details/${endUserId}/fiscal-bills/details/${fiscalBillId}`,
};

// FiscalBills
const FiscalBillsRoot = `${RootRoute}/fiscal-bills`;
export const FiscalBillsRoutes = {
  root: FiscalBillsRoot,
  index: `${FiscalBillsRoot}/index`,
  details: `${FiscalBillsRoot}/details/:fiscalBillId`,
  buildDetails: (fiscalBillId: string) => `${RootRoute}/fiscal-bills/details/${fiscalBillId}`,
};
// FiscalItemClaims
const FiscalItemClaimsRoot = `${RootRoute}/fiscal-item-claims`;
export const FiscalItemClaimsRoutes = {
  root: FiscalItemClaimsRoot,
  index: `${FiscalItemClaimsRoot}/index`,
  details: `${FiscalItemClaimsRoot}/details/:fiscalItemClaimId`,
  buildDetails: (fiscalItemClaimId: string) =>
    `${RootRoute}/fiscal-item-claims/details/${fiscalItemClaimId}`,
};

// PushNotifications
const PushNotificationsRoot = `${RootRoute}/push-notifications`;
export const PushNotificationsRoutes = {
  root: PushNotificationsRoot,
  index: `${PushNotificationsRoot}/index`,
  sendNotification: `${PushNotificationsRoot}/send-notification`,
};

const AdminRoot = `${RootRoute}/admin-users`;
export const AdminUsersRoutes = {
  root: AdminRoot,
  index: `${AdminRoot}/index`,
  details: `${AdminRoot}/details`,
  create: `${AdminRoot}/create`,
};

export const AgentRoot = `${RootRoute}/agents`;
export const AgentsRoutes = {
  root: AgentRoot,
  indexInternal: `${AgentRoot}/internal/index`,
  indexExternal: `${AgentRoot}/external/index`,
  details: `${AgentRoot}/details`,
};

const UserRoot = `${RootRoute}/user`;
export const UserRoutes = {
  root: UserRoot,
  commonProfile: `${UserRoot}/profile`,
};

export const UserManagementRoot = `${RootRoute}/user-management`;

const ProductApprovalOperaterUsersRoot = `${UserManagementRoot}/product-approval-operater-users`;
export const ProductApprovalOperaterUsersRoutes = {
  root: ProductApprovalOperaterUsersRoot,
  create: `${ProductApprovalOperaterUsersRoot}/create`,
};

const ContentEditorUsersRoot = `${UserManagementRoot}/content-editor-users`;
export const ContentEditorUsersRoutes = {
  root: ContentEditorUsersRoot,
  create: `${ContentEditorUsersRoot}/create`,
};

const UnderwriterUsersRoot = `${UserManagementRoot}/underwriter-users`;
export const UnderwriterUsersRoutes = {
  root: UnderwriterUsersRoot,
  create: `${UnderwriterUsersRoot}/create`,
};

const PlatformAdminUsersRoot = `${UserManagementRoot}/platform-admin-users`;
export const PlatformAdminUsersRoutes = {
  root: PlatformAdminUsersRoot,
  create: `${PlatformAdminUsersRoot}/create`,
};

const InsuranceAdminUsersRoot = `${UserManagementRoot}/insurance-admin-users`;
export const InsuranceAdminUsersRoutes = {
  root: InsuranceAdminUsersRoot,
  create: `${InsuranceAdminUsersRoot}/create`,
};

export const InsuranceAgentUsersRoot = `${UserManagementRoot}/insurance-agent-users`;
export const InsuranceAgentUsersRoutes = {
  root: InsuranceAgentUsersRoot,
  create: `${InsuranceAgentUsersRoot}/create`,
};

//------------------ Login ------------------
export const LoginRoot = `/login`;
export const ForbiddenRoot = `${LoginRoot}/forbidden`;
//------------------ End user routes ------------------

const HomePagsRoot = `${RootRoute}`;
export const HomePagesRoutes = {
  root: HomePagsRoot,
  contentEditorHomePage: `${HomePagsRoot}/chome-page`,
  underwriterHomePage: `${HomePagsRoot}/uhome-page`,
  productApprovalOperaterHomePage: `${HomePagsRoot}/phome-page`,
  platformAdminHomePage: `${HomePagsRoot}/pahome-page`,
  insuranceAdminHomePage: `${HomePagsRoot}/inhome-page`,
  insuranceAgentHomePage: `${HomePagsRoot}/ihome-page`,
  distributorHomePage: `${HomePagsRoot}/dhome-page`,
  retailerHomePage: `${HomePagsRoot}/rhome-page`,
};
